'use strict';

const dimensions = require('./dimensions');
const trackEvent = require('./trackEvent');

let queue;

if (typeof window.lftrack === 'function') {
    queue = window.lftrack.q;
}

window.lftrack = function(metric, eventName = null, options = {}) {
    if (!metric) {
        return false;
    }
    return trackEvent(metric, eventName, dimensions(options));
};

if (typeof queue !== 'undefined') {
    queue.forEach(element => {
        window.lftrack.apply(window, element); // IE-compatible without polyfill (no REST operator usage)
    });
}
